"use client";

import { useRef, useState } from "react";
import CarouselCard from "@/components/portfolio/carousel/CarouselCard";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { CarouselSkeletonCard } from "@/components/portfolio/carousel/CarouselSkeletonCard";
import SliderNav from "@/components/portfolio/SliderNav";
import { useGSAP } from "@gsap/react";
import hasTextMovAnim from "@/lib/animation/hasTextMovAnim";

import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCarousel } from "@/lib/plugins";

import "@/styles/swiper-slider.css";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { cn } from "@/lib/utils";

type Props = {
  title?: string;
  data: {
    image: string;
    image_mobile?: string;
    title: string;
    tag: string;
  }[];
};

const PortfolioCarousel = ({ title, data }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null!);
  const [isLoading, setIsLoading] = useState(true);

  useGSAP(
    () => {
      hasTextMovAnim();
    },
    { scope: containerRef },
  );

  return (
    <section className="inner-container-2 section-spacing-top">
      <div className="pb-[100px] md:pb-[120px]" ref={containerRef}>
        {title && (
          <div className="mb-10 md:mb-16">
            <h2 className="text-center text-[28px] md:text-[34px] lg:text-[40px] font-bold leading-tight tracking-tight has_text_mov_anim">
              {title}
            </h2>
          </div>
        )}
        <div
          id="app"
          className="relative z-10 h-full flex items-center justify-center"
        >
          {isLoading && (
            <div className=" !mx-auto pos-center">
              <CarouselSkeletonCard />
            </div>
          )}
          <Swiper
            className={cn(
              "swiper-carousel !max-w-[1400px] relative !mx-auto !overflow-hidden opacity-100",
              isLoading && "opacity-0",
            )}
            modules={[EffectCarousel, Navigation, Pagination, Autoplay]}
            dir="ltr"
            effect="carousel"
            grabCursor={true}
            loop={true}
            loopAdditionalSlides={1}
            slidesPerView="auto"
            navigation={{
              nextEl: ".portfolio-button-next",
              prevEl: ".portfolio-button-prev",
            }}
            // pagination={{
            //   el: ".portfolio-pagination",
            //   clickable: true,
            // }}
            autoplay={{
              delay: 3000,
            }}
            onInit={(swiper) => {
              setIsLoading(false);
            }}
          >
            {data.map((item, index) => (
              <SwiperSlide
                key={index}
                className="swiper-slide !h-[260px] !w-[260px] sm:!h-[360px] sm:!w-[360px] md:!h-[400px] md:!w-[600px] xl:!h-[450px] xl:!w-[700px] 2xl:!h-[550px] 2xl:!w-[800px] !max-w-[calc(100%-16px)] sm:!max-w-[calc(100%-48px)]"
              >
                <CarouselCard {...item} />
              </SwiperSlide>
            ))}
          </Swiper>
          <SliderNav position="top" />
        </div>
      </div>
    </section>
  );
};

export default PortfolioCarousel;
